import React from "react";
import styles from "./ImageGallery.module.css";

const ImageGallery = ({ images }) => {
  return (
    <div className={styles.galleryWrapper}>
        <div className={`${styles.gallery} ${styles[`gallery-${images.length}`]}`}>
            {images.map((src, index) => (
                <div
                key={index}
                className={`${styles.galleryItem} ${index === 0 ? styles.firstImage : styles.otherImage}`}
                style={{ backgroundImage: `url(${src})` }}
                ></div>
            ))}
        </div>
    </div>
    
  );
};

export default ImageGallery;
